import React from 'react';
import App from '@app';
import { Result, Icon, Body } from '@components';

export default function Home() {
  return (
    <App>
      <Body>
        <Result
          title="Aguarde, novidades em breve!"
          icon={(
            <Icon.SmileTwoTone />
          )}          
        />
      </Body>
    </App>
  );
}
